module.exports = __webpack_public_path__ + "static/media/EmotionalDiffusionTechniques.3b5f97ed.mp3";